import * as api from '../linksApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FetchLinks,
    ILink,
    linkActionCreators,
    LinkActionKeys
    } from '..';
import { uiActionCreators } from '../../ui';

function* fetchLinksSaga(action: FetchLinks) {
  yield put(uiActionCreators.toggleLoading('links'));

  const links: ILink[] = yield call(api.fetchLinks, action.payload.type);

  yield put(linkActionCreators.setLinks(links));
  yield put(uiActionCreators.toggleLoading('links'));
}

export function* watchFetchLinks() {
  yield takeEvery(LinkActionKeys.FETCH_LINKS, fetchLinksSaga);
}
